import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function (state = initialState.patientOtp, {type, payload}){
    switch(type){
        case types.PATIENT_OTP:
            return {
                isLoading: true,
                isStatus: 'request',
                request: payload,
                response: {},
            };
        case types.PATIENT_OTP_SUCCESS:
            return{
                ...state,
                isLoading: false,
                isStatus: 'success',
                response: payload,
            };
        case types.PATIENT_OTP_FAILURE:
            return {
                ...state,
                isLoading: false,
                isStatus: 'error',
                response: payload,
            };
        default:
            return state;
    }
}